<!-- Main Container -->
<div *ngIf="!loading" class="flex flex-col h-[calc(92vh-65px)] overflow-y-auto min-w-[300px]">

    <!-- Progress Bar -->
  <div class="flex justify-center items-center mb-4 min-h-[20px]" *ngIf="loadingData && !loading">
  <div class="flex space-x-1">
    <span class="w-3 h-3 bg-blue-500 rounded-full animate-bounce-delay"></span>
    <span class="w-3 h-3 bg-blue-500 rounded-full animate-bounce-delay200"></span>
    <span class="w-3 h-3 bg-blue-500 rounded-full animate-bounce-delay400"></span>
  </div>
</div>


    <!-- Header Actions -->
<div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">

  <!-- Bulk Delete Icon with Tooltip -->
  <div *ngIf="selectedIds.length > 0" class="flex items-center gap-2">
    <p-button 
      icon="pi pi-trash" 
      styleClass="p-button-rounded p-button-danger p-button-outlined p-button-sm hover:scale-105 transition-transform duration-200 shadow-md"
      (onClick)="openDeleteGroup()" 
      badgeClass="p-badge-danger"
      pTooltip="Delete selected emails" 
      tooltipPosition="bottom">
    </p-button>
    <span class="text-sm text-gray-600 hidden sm:inline">
      {{ selectedIds.length }} email(s) selected
    </span>
  </div>

  <!-- Search Input with Icon and Focus Effect -->
  <div class="flex-1 relative w-full">
    <span class="p-input-icon-right w-full">
      <i class="pi pi-search text-gray-400 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"></i>
      <input 
        id="email-search-input-unique-mailhub"
        name="emailSearchInputMailHub"
        type="text" 
        pInputText 
        placeholder="Search emails..." 
        [formControl]="searchQuery"
        autocomplete="new-password"
        autocapitalize="off"
        autocorrect="off"
        spellcheck="false"
        class="w-full pl-12 pr-4 py-2 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 hover:shadow-md">
    </span>
  </div>

</div>


    <!-- Email List -->
    <div #scrollContainer class="flex-1 overflow-y-auto overflow-x-hidden pr-2 space-y-3"
        (scroll)="onScroll(scrollContainer)">

        <!-- Email Items -->
        <div *ngFor="let element of dataSource; trackBy: trackByEmailId"
            class="bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md hover:border-blue-200 transition-all duration-200 relative group">

            <!-- Email Content -->
            <div class="p-4 cursor-pointer relative" (click)="setSeelctRow(element)"
                (mouseenter)="hoverelmentId = element?.id" (mouseleave)="hoverelmentId = null">

                <!-- Hover Overlay with Actions -->
                <div *ngIf="hoverelmentId == element?.id || selectedIds.length > 0"
                    class="absolute inset-0 bg-black bg-opacity-10 rounded-xl flex justify-between items-start p-3 z-10">

                    <!-- Checkbox -->
                    <div class="flex items-center">
                        <p-checkbox [binary]="true" (click)="$event.stopPropagation()"
                            (onChange)="updateSelection(element)" styleClass="mr-2">
                        </p-checkbox>
                    </div>

                    <!-- Delete Action -->
                    <div>
                        <p-button icon="pi pi-trash"
                            styleClass="p-button-rounded p-button-danger p-button-text p-button-sm mr-5 -mt-2"
                            (onClick)="openDeleteGroup2(element?.id)" pTooltip="Delete email" tooltipPosition="left">
                        </p-button>
                    </div>
                </div>

                <!-- Email Header -->
                <div class="flex items-center gap-3 mb-3">

                    <!-- Avatar -->
                    <div class="flex-shrink-0"
                        [class.invisible]="hoverelmentId == element?.id || selectedIds.length > 0">
                        <div
                            class="w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center text-white font-semibold text-sm shadow-md">
                            {{ getInitials(element?.sender?.emailAddress?.name || currentUser || 'Unknown User') }}
                        </div>
                    </div>

                    <!-- Sender Info -->
                    <div class="flex-1 min-w-0">
                        <div class="font-semibold text-gray-900 truncate text-base">
                            {{ element?.sender?.emailAddress?.name || 'Unknown Sender' }}
                        </div>
                        <div class="text-sm text-gray-500 flex items-center gap-2 mt-2">
                            <i class="pi pi-clock text-xs"></i>
                            {{ element?.receivedDateTime | date: 'MMM d, y, h:mm a' }}
                        </div>
                    </div>

                    <!-- Status Indicators -->
                    <div class="flex items-center gap-2">
                        <!-- Unread indicator -->
                        <!-- <div *ngIf="!element?.isRead" class="w-2 h-2 bg-blue-500 rounded-full"></div> -->

                        <!-- Important indicator -->
                        <i *ngIf="element?.importance === 'high'"
                            class="pi pi-exclamation-triangle text-orange-500 text-sm"></i>

                        <!-- Attachment indicator -->
                        <i *ngIf="element?.hasAttachments" class="pi pi-paperclip text-gray-400 text-sm"></i>
                    </div>
                </div>

                <!-- Subject -->
                <div class="font-medium text-gray-900 truncate mb-2 text-base">
                    {{ element.subject || 'No Subject' }}
                </div>

                <!-- Body Preview -->
                <div class="text-sm text-gray-600 line-clamp-2 leading-relaxed">
                    {{ element.bodyPreview || 'No preview available' }}
                </div>
            </div>
        </div>

        <!-- No Data State -->
        <div *ngIf="!dataSource || dataSource.length === 0" class="text-center py-12">
            <div class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i class="pi pi-inbox text-2xl text-gray-400"></i>
            </div>
            <h3 class="text-lg font-medium text-gray-900 mb-2">No emails found</h3>
            <p class="text-gray-500">Your {{ activeAction }} folder is empty.</p>
        </div>

        <!-- Load More Progress -->
        <div class="mt-4 flex justify-center">
            <div *ngIf="loadMore" class="flex justify-center items-center mb-4 min-h-[20px]">
              <div class="flex space-x-1">
                <span class="w-3 h-3 bg-blue-500 rounded-full animate-bounce-delay"></span>
                <span class="w-3 h-3 bg-blue-500 rounded-full animate-bounce-delay200"></span>
                <span class="w-3 h-3 bg-blue-500 rounded-full animate-bounce-delay400"></span>
              </div>
            </div>
        </div>

    </div>
</div>

<!-- Loading State -->
<div *ngIf="loading" class="h-[calc(92vh-65px)] flex flex-col items-center justify-center">
    <div class="text-center">
        <div class="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mx-auto mb-4"></div>
        <p class="text-gray-600">Loading emails...</p>
    </div>
</div>

<!-- Delete Confirmation Dialog -->
<p-dialog header="Delete Email" appendTo="body" [modal]="true" [(visible)]="showDeleteDialog" [breakpoints]="{ '1199px': '65vw', '575px': '90vw' }"
  closable="false" [style]="{ width: '45vw' }" [draggable]="false" [resizable]="false">

    <!-- Dialog Content -->
    <div class="p-6">
        <div class="flex items-start gap-4">
            <!-- Warning Icon -->
            <div class="flex-shrink-0">
                <div class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                    <i class="pi pi-exclamation-triangle text-red-600 text-xl"></i>
                </div>
            </div>

            <!-- Message Content -->
            <div class="flex-1">
                <h3 class="text-lg font-semibold text-gray-900 mb-3">
                    Are you sure you want to delete
                    <span *ngIf="selectedIds.length <= 1">this email</span>
                    <span *ngIf="selectedIds.length > 1">these {{ selectedIds.length }} emails</span>?
                </h3>
                <div class="space-y-3">
                    <p class="text-gray-600">
                        This action will move the email(s) to your trash folder.
                    </p>
                    <div class="bg-red-50 border border-red-200 rounded-lg p-3">
                        <div class="flex items-center gap-2">
                            <i class="pi pi-info-circle text-red-500"></i>
                            <span class="text-red-700 text-sm font-medium">
                                Note: You will not be able to undo this action
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Dialog Footer -->
    <ng-template pTemplate="footer">
        <div class="flex gap-3 justify-end p-4">
            <p-button label="Cancel" icon="pi pi-times" styleClass="p-button-text p-button-secondary"
                (onClick)="closeDeleteDialog()">
            </p-button>

            <p-button label="Delete" icon="pi pi-trash" styleClass="p-button-danger p-button-raised"
                [loading]="btnLoading" (onClick)="handleDeleteEvent()">
            </p-button>
        </div>
    </ng-template>
</p-dialog>

<!-- Toast for notifications -->
<p-toast position="top-right"></p-toast>